import {createContext} from 'react';

export const ApplicantContext = createContext<{isCoreCustomer?: boolean}>({
  isCoreCustomer: undefined
});
